import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function SettingsTab() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="text-stone-400"><Loader2 className="w-5 h-5 animate-spin" /></div>;

  const setCompany = (k, v) => setS((x) => ({ ...x, company: { ...x.company, [k]: v } }));
  const setHero = (lng, v) => setS((x) => ({ ...x, hero_tagline: { ...x.hero_tagline, [lng]: v } }));

  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/admin/settings", s); setS(r.data); toast.success("Настройки сохранены"); }
    catch (e) { toast.error("Ошибка сохранения"); }
    finally { setSaving(false); }
  };

  const inputCls = "w-full px-3 py-2 rounded-lg border border-stone-300 text-sm outline-none focus:border-[#1E3A2F]";
  const companyFields = [["name", "Название компании"], ["cvr", "CVR"], ["email", "E-mail"], ["phone", "Телефон"], ["address", "Адрес"], ["city", "Город"]];

  return (
    <div className="space-y-6 max-w-2xl" data-testid="admin-settings-tab">
      <div className="bg-white border border-stone-200 rounded-2xl p-5">
        <h3 className="font-semibold text-stone-900 mb-4">Данные компании</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          {companyFields.map(([k, label]) => (
            <div key={k}>
              <label className="block text-xs text-stone-500 mb-1">{label}</label>
              <input className={inputCls} value={s.company[k] || ""} onChange={(e) => setCompany(k, e.target.value)} data-testid={`settings-company-${k}`} />
            </div>
          ))}
        </div>
        <label className="flex items-center gap-2 mt-4 text-sm">
          <input type="checkbox" className="w-4 h-4 accent-[#1E3A2F]" checked={s.service_available} onChange={(e) => setS((x) => ({ ...x, service_available: e.target.checked }))} data-testid="settings-service-available" />
          Сервис доступен (принимает заявки)
        </label>
      </div>

      <div className="bg-white border border-stone-200 rounded-2xl p-5">
        <h3 className="font-semibold text-stone-900 mb-1">Минимальная сумма заказа (с НДС)</h3>
        <p className="text-xs text-stone-500 mb-3">Только справочное значение — не применяется автоматически. Используется как ориентир при расчёте небольших заказов.</p>
        <div className="relative max-w-xs">
          <input type="number" step="0.01" min="0" className={inputCls} placeholder="напр. 900"
            value={s.minimum_order_price_incl_vat ?? ""}
            onChange={(e) => setS((x) => ({ ...x, minimum_order_price_incl_vat: e.target.value === "" ? null : parseFloat(e.target.value) }))}
            data-testid="settings-min-order-price" />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-stone-400">DKK</span>
        </div>
      </div>

      <div className="bg-white border border-stone-200 rounded-2xl p-5">
        <h3 className="font-semibold text-stone-900 mb-4">Слоган на главной</h3>
        <div className="space-y-3">
          <div>
            <label className="block text-xs text-stone-500 mb-1">Датский</label>
            <input className={inputCls} value={s.hero_tagline?.da || ""} onChange={(e) => setHero("da", e.target.value)} data-testid="settings-hero-da" />
          </div>
          <div>
            <label className="block text-xs text-stone-500 mb-1">Английский</label>
            <input className={inputCls} value={s.hero_tagline?.en || ""} onChange={(e) => setHero("en", e.target.value)} data-testid="settings-hero-en" />
          </div>
        </div>
      </div>

      <button onClick={save} disabled={saving} className="px-6 py-3 rounded-full bg-[#1E3A2F] text-white font-semibold disabled:opacity-60" data-testid="settings-save-btn">
        {saving ? "Сохранение…" : "Сохранить настройки"}
      </button>
    </div>
  );
}
